import {PolicyTypeList} from "./PolicyTypeList";
import {PolicyTypeEdit} from "./PolicyTypeEdit";
import {PolicyTypeCreate} from "./PolicyTypeCreate";

export default {
    list: PolicyTypeList,
    create: PolicyTypeCreate,
    edit: PolicyTypeEdit
};
